import { FC } from 'react';

import { IoMdClose } from 'react-icons/io';

import Image from 'next/image';

import { useTheme } from 'styled-components';
import { IconButton } from '@mui/material';

import { MonteiroEngenhariaLogoWrapper } from './styles';
import logo from '../../../../public/images/logo.png';

interface IProps {
  width?: number;
  height?: number;
  src?: string | null;
  alt?: string;
  fallbackToDefaultLogo?: boolean;
  openSidebarDrawer?: boolean;
  setOpenSidebarDrawer?: (open: boolean) => void;
  showCloseButton?: boolean;
}

/** @todo - alterar para genérico */
export const MonteiroEngenhariaLogo: FC<IProps> = ({
  width = 300,
  height = 88,
  src,
  alt = 'Monteiro Engenharia',
  fallbackToDefaultLogo = true,
  openSidebarDrawer,
  setOpenSidebarDrawer,
  showCloseButton = false,
}) => {
  const theme = useTheme();

  return (
    <MonteiroEngenhariaLogoWrapper>
      {src ? (
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          style={{
            objectFit: 'contain',
          }}
        />
      ) : fallbackToDefaultLogo ? (
        <Image src={logo.src} alt={alt} width={width} height={height} />
      ) : null}
      {showCloseButton && (
        <IconButton onClick={() => setOpenSidebarDrawer(!openSidebarDrawer)}>
          <IoMdClose size={20} color={theme.neutral[400]} />
        </IconButton>
      )}
    </MonteiroEngenhariaLogoWrapper>
  );
};
